import React from 'react';
import PercentInput from 'components/PercentInput';

type Props = {
  source: string;
};

export const BlendedRateMarkupInput = ({ source }: Props) => {
  return (
    <PercentInput
      source={`${source}.blended_rates.blended_rate_markup`}
      label="Blended Rate Markup"
      disabled
    />
  );
};
